(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["popup-custom"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const popup = document.querySelector('.popup-model-form');
    if (!popup) return;

    const openBtn = document.querySelector('.live-video-shop-btn');
    const closeBtn = popup.querySelector('.close-svg');
    const overlay = popup.querySelector('.popup-overlay');

    // Open popup
    openBtn?.addEventListener('click', () => {
      popup.classList.add('active');
      document.body.classList.add('no-scroll');
    });

    // Close popup function
    const closePopup = () => {
      popup.classList.remove('active');
      document.body.classList.remove('no-scroll');
    };

    // Close events
    closeBtn?.addEventListener('click', closePopup);
    overlay?.addEventListener('click', closePopup);
  });
  } catch(e) { console.error(e); }
})();

})();
